import React from 'react';
import styled from 'styled-components';
import MultimediaIcon from 'apps/web_forms/assets/errorgraphic.svg';
import { APP_ROUTES, COLORS } from 'apps/web_forms/utils/constants';
import { useHistory, useParams } from 'react-router-dom';
import { isPublicForm } from 'apps/web_forms/api/api';

const StyledForm = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  .error-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 25em;
    width: 35em;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    background-color: white;

    .error-icon {
      width: 100%;
      height: 15em;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .main-error-text {
      width: 100%;
      height: 2em;
      text-align: center;
      font-weight: bold;
      font-size: 1.3em;
    }

    .help-tip {
      width: 100%;
      height: 2em;
      text-align: center;
    }

    .buttons {
      width: 100%;
      height: 4em;
      display: flex;
      justify-content: center;
      align-items: center;
      button {
        border: 2px solid ${COLORS.primary};
        background-color: transparent;
        color: ${COLORS.primary};
        border-radius: 15px;
        height: 2em;
        width: 9em;
        font-weight: 500;
        font-family: 'Helvetica', 'Roboto';
        font-size: 13px;
        &.filled-button {
          color: white;
          background-color: ${COLORS.primary};
          &:hover {
            background-color: ${`${COLORS.primary}de`};
            border-color: ${`${COLORS.primary}de`};
          }
        }
      }
    }
  }
`;

const errorMessages = {
  404: {
    mainErrorText: 'OOPS! The item you are looking for does not exist.',
    helpTip: 'Please press the button below to go to the main page.',
  },
  500: {
    mainErrorText: 'OOPS! Well, this is unexpected...',
    helpTip: 'An error has ocurred and we are working to fix the problem!',
  },
};

const ErrorPage = () => {
  const { errorId } = useParams();
  const messages = errorMessages[errorId] ?? errorMessages[500];
  const history = useHistory();

  const goToForms = () => history.push(APP_ROUTES.formsPage);

  return (
    <StyledForm>
      <div className="error-box">
        <div className="error-icon">
          <MultimediaIcon />
        </div>
        <div className="main-error-text">{messages?.mainErrorText}</div>
        <div className="help-tip">{messages?.helpTip}</div>
        {!isPublicForm() && <div className="buttons">
          <button className="filled-button" type="button" onClick={goToForms}>
            Go to forms page
          </button>
        </div>}
      </div>
    </StyledForm>
  );
};

export default ErrorPage;
